'use strict';
import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

$(document).ready(function () {
    if (window.innerWidth < 768) {
        $('.image-wall__mobile').each(function () {
            const slider = new Swiper(this, { // eslint-disable-line no-unused-vars
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,
                centeredSlides: true,
            });
        });
    }
});
